import React from 'react'
import '../styles/header.css'
import CV from "../images/cv.pdf";
import {BsLinkedin} from 'react-icons/bs';
import {BsGithub} from 'react-icons/bs'
import {BsWhatsapp} from 'react-icons/bs'
import one from '../images/1.jpg'
import {HiOutlineFolderDownload} from 'react-icons/hi';

const Header = () => {

  function Cv(){
    return <div className="cta">
      <a className='btn ' href={CV} download>Download Resume</a>
      <a className='btn btn-primary' href="#contact">Let's catch up</a>
    </div>
  }

  
  const Socials = () => {
    return (
      <div className='header_socials'>
        <a href="https://www.linkedin.com/in/somesh-nitnavare/" target="_blank"><BsLinkedin /></a>
        <a href="https://github.com/SomeshN-GitHub" target="_blank"><BsGithub /></a>
        <a href="https://wa.me/+918793826140" target="_blank"><BsWhatsapp /></a>
      </div>
    );
  }
  
  return (
    <header>
      <div className='container header_container'>
        <div className='intro'>
        <h3 className='hello'>Hello I'm</h3>
        <h1>Somesh Nitnavare</h1>
        <h3 className="text-light">Frontend Developer</h3>
        <Cv />
        </div>
        <Socials />
        {/* <div className="me">
          <img src={one} alt="" />
        </div> */}
        <a href="#contact"  className='scroll-down'>Scroll Down</a>

      </div>

    </header>
  )
}

export default Header